export default {
  variants: {
    primary: {
      filledTrack: {
        bg: "primary.dark",
      },
    },
  },
};
